const veolia1ReportData = {
  header: {
    reportId: "VEOLIA-RP11-1",
    businessName: "Veolia Holdings Australia Pty Ltd",
    abn: "82663593093",
    acn: "663593093",
    arbn: null,
    entityInfoConfirmed: null,
    reportingPeriodLabel: "Reporting Period 11",
    reportingPeriodStartDate: "2026-01-01",
    reportingPeriodEndDate: "2026-06-30",
    datasetLabel: "TCP dataset",
  },
  declarations: {
    approvingResponsibleMemberGivenName: null,
    approvingResponsibleMemberFamilyName: null,
    responsibleMemberApprovalDate: null,
    supplyChainFinanceOffered: null,
    procurementFeesCharged: null,
    smallBusinessPaymentObligations: null,
    reportComments: null,
    descriptionOfChanges: null,
  },
  computed: {
    averagePaymentTimeDays: 29.49,
    medianPaymentTimeDays: 26.0,
    p80PaymentTimeDays: 44,
    p95PaymentTimeDays: 65,
    percentageOfSbInvoicesPaidWithinPaymentTerm: 47.05,
    percentageOfSmallBusinessTradeCreditPayments: 36.16,
    payments30DaysOrLessPct: 62.4,
    payments31To60DaysPct: 26.19,
    paymentsMoreThan60DaysPct: 11.42,
    commonPaymentTermsDays: 27,
    receivableTermsComparedToCommonPaymentTerm: "Longer",
    commonPaymentTermMinimum: 1,
    commonPaymentTermMaximum: 45,
    forecastPaymentTerm: 27,
    forecastMinimumPaymentTerm: 1,
    forecastMaximumPaymentTerm: 45,
    percentagePeppolEnabledSmallBusinessProcurement: 0,
  },
  previousCycle: {
    p95PaymentTimeDays: 64,
    relativePositionNote:
      "P95 increased by 1 day, from 64 to 65 days. While 62.40% of payments are made within 30 days, 52.95% of small business trade credit arrangements are paid outside payment terms.",
  },
  supplierSignals: {
    lateSbRate: 0.5295,
    slowestPaidSuppliers: [],
    invoiceBands: [
      { label: "0–30 days", pct: 62.4 },
      { label: "31–60 days", pct: 26.19 },
      { label: "61+ days", pct: 11.42 },
    ],
  },
  quality: {
    blocked: false,
    basedOnRowCount: 74511,
    missingInputs: [],
    notes: [
      "P95 increased 1 day: 64 → 65 days.",
      "Median is 26 days against the most common 27-day term.",
      "37.61% of payments take more than 30 days.",
      "Small business payments represent 36.16% of total trade credit payments.",
    ],
  },
};

const veolia2ReportData = {
  header: {
    reportId: "VEOLIA-RP11-2",
    businessName: "Veolia Water Technologies 2 Pty Ltd",
    abn: "30616561829",
    acn: "616561829",
    arbn: null,
    entityInfoConfirmed: null,
    reportingPeriodLabel: "Reporting Period 11",
    reportingPeriodStartDate: "2026-01-01",
    reportingPeriodEndDate: "2026-06-30",
    datasetLabel: "TCP dataset",
  },
  declarations: {
    approvingResponsibleMemberGivenName: null,
    approvingResponsibleMemberFamilyName: null,
    responsibleMemberApprovalDate: null,
    supplyChainFinanceOffered: "No",
    procurementFeesCharged: "No",
    smallBusinessPaymentObligations: "No",
    reportComments: null,
    descriptionOfChanges: null,
  },
  computed: {
    averagePaymentTimeDays: 38.44,
    medianPaymentTimeDays: 32.0,
    p80PaymentTimeDays: 56,
    p95PaymentTimeDays: 64,
    percentageOfSbInvoicesPaidWithinPaymentTerm: 37.03,
    percentageOfSmallBusinessTradeCreditPayments: 48.06,
    payments30DaysOrLessPct: 40.81,
    payments31To60DaysPct: 48.11,
    paymentsMoreThan60DaysPct: 11.08,
    commonPaymentTermsDays: 27,
    receivableTermsComparedToCommonPaymentTerm: "Longer",
    commonPaymentTermMinimum: 27,
    commonPaymentTermMaximum: 27,
    forecastPaymentTerm: 27,
    forecastMinimumPaymentTerm: 27,
    forecastMaximumPaymentTerm: 27,
    percentagePeppolEnabledSmallBusinessProcurement: 0,
  },
  previousCycle: {
    p95PaymentTimeDays: 66,
    relativePositionNote:
      "P95 improved by 2 days, from 66 to 64 days. However, broader payment performance remains weak, with 59.19% of payments taking more than 30 days.",
  },
  supplierSignals: {
    lateSbRate: 0.6297,
    slowestPaidSuppliers: [],
    invoiceBands: [
      { label: "0–30 days", pct: 40.81 },
      { label: "31–60 days", pct: 48.11 },
      { label: "61+ days", pct: 11.08 },
    ],
  },
  quality: {
    blocked: false,
    basedOnRowCount: 365,
    missingInputs: [],
    notes: [
      "P95 improved 2 days: 66 → 64 days.",
      "Median remains 5 days beyond the most common 27-day term.",
      "48.11% of payments sit in the 31–60 day band — the largest improvement opportunity.",
      "Small business payments represent 48.06% of total trade credit payments.",
    ],
  },
};

const cosolReportData = {
  header: {
    reportId: "COSOL-RP10",
    businessName: "Cosol",
    abn: "66635371363",
    acn: "635371363",
    arbn: null,
    entityInfoConfirmed: null,
    reportingPeriodLabel: "Reporting Period 10",
    reportingPeriodStartDate: "2025-07-01",
    reportingPeriodEndDate: "2025-12-31",
    datasetLabel: "TCP dataset",
  },
  declarations: {
    approvingResponsibleMemberGivenName: null,
    approvingResponsibleMemberFamilyName: null,
    responsibleMemberApprovalDate: null,
    supplyChainFinanceOffered: "No",
    procurementFeesCharged: "No",
    smallBusinessPaymentObligations: "No",
    reportComments: null,
    descriptionOfChanges: null,
  },
  computed: {
    averagePaymentTimeDays: 22.38,
    medianPaymentTimeDays: 16,
    p80PaymentTimeDays: 32,
    p95PaymentTimeDays: 48,
    percentageOfSbInvoicesPaidWithinPaymentTerm: 67.99,
    percentageOfSmallBusinessTradeCreditPayments: 14.7,
    payments30DaysOrLessPct: 74.07,
    payments31To60DaysPct: 23.02,
    paymentsMoreThan60DaysPct: 2.91,
    commonPaymentTermsDays: 62,
    receivableTermsComparedToCommonPaymentTerm: "Longer",
    commonPaymentTermMinimum: 7,
    commonPaymentTermMaximum: 62,
    forecastPaymentTerm: 62,
    forecastMinimumPaymentTerm: 7,
    forecastMaximumPaymentTerm: 62,
    percentagePeppolEnabledSmallBusinessProcurement: 0,
  },
  previousCycle: {
    p95PaymentTimeDays: 31,
    relativePositionNote:
      "Placeholder: add Cosol previous-cycle context and regulator positioning here.",
  },
  supplierSignals: {
    lateSbRate: null,
    slowestPaidSuppliers: [],
    invoiceBands: [],
  },
  quality: {
    blocked: false,
    basedOnRowCount: 6633,
    missingInputs: [],
    notes: ["Placeholder: add Cosol report notes here."],
  },
};

const ptrsReportDataSets = {
  veolia1: veolia1ReportData,
  veolia2: veolia2ReportData,
  cosol: cosolReportData,
};

export default ptrsReportDataSets;
